module.exports = __webpack_public_path__ + "assets/img/1015.a378f5eb.svg";